'use strict';

exports.__esModule = true;
exports.MobileMenu = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _doctifyUtils = require('doctify-utils');

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

var _profileListItem = require('./profile-list-item');

var _topNavLinks = require('./top-nav-links');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileMenu = function MobileMenu(props) {
	var overlay = void 0;

	var onlineGP = '';
	var pageName = props.pageName,
	    loggedIn = props.loggedIn,
	    currentProfile = props.currentProfile,
	    availableProfiles = props.availableProfiles,
	    mobileMenuOpen = props.mobileMenuOpen,
	    logOut = props.logOut,
	    openSignUpModal = props.openSignUpModal,
	    openMobileSearchMenu = props.openMobileSearchMenu,
	    openReviewModal = props.openReviewModal,
	    toggleMobileMenu = props.toggleMobileMenu,
	    toggleMobileProfiles = props.toggleMobileProfiles,
	    showAvailableProfilesMobile = props.showAvailableProfilesMobile,
	    searchJournal = props.searchJournal,
	    intl = props.intl,
	    onProfileClicked = props.onProfileClicked;

	var profileElements = availableProfiles.map(function (profile, key) {
		return _react2.default.createElement(_profileListItem.ProfileListItem, { key: key, profile: profile, currentProfile: currentProfile, onProfileClicked: onProfileClicked });
	});
	var profileInfo = currentProfile.type !== 'patient' ? _react2.default.createElement(
		'div',
		null,
		availableProfiles && _react2.default.createElement(
			'a',
			{ href: '#',
				onClick: function onClick() {
					toggleMobileProfiles();
				} },
			_react2.default.createElement('i', { className: 'ion-ios-arrow-down' }),
			_react2.default.createElement(
				'span',
				{ className: _style.capitalize },
				currentProfile.name
			)
		),
		_react2.default.createElement(
			'ul',
			{ className: _style.availableUsersList + ' ' + (showAvailableProfilesMobile ? '' : _style.hidden) },
			profileElements
		),
		_react2.default.createElement(
			'a',
			{ href: '/' + currentProfile.type + '/' + currentProfile.uri_id + '/edit/account' },
			_react2.default.createElement('i', { className: 'ion-gear-b' }),
			_react2.default.createElement(
				'span',
				null,
				intl.formatMessage(_defaultMessages2.default.MY_ACCOUNT)
			)
		)
	) : _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			'a',
			{ href: onlineGP },
			_react2.default.createElement('i', { className: 'ion-ios-email-outline' }),
			_react2.default.createElement(
				'span',
				null,
				intl.formatMessage(_defaultMessages2.default.GET_A_REFERRAL)
			)
		),
		_react2.default.createElement(
			'a',
			{ href: '/patient/' + currentProfile.uri_id + '/edit/account' },
			_react2.default.createElement('i', { className: 'ion-ios-person-outline' }),
			_react2.default.createElement(
				'span',
				null,
				intl.formatMessage(_defaultMessages2.default.MY_ACCOUNT)
			)
		),
		_react2.default.createElement(
			'a',
			{ href: '/patient/' + currentProfile.uri_id + '/edit/appointments' },
			_react2.default.createElement('i', { className: 'ion-ios-list-outline' }),
			_react2.default.createElement(
				'span',
				null,
				intl.formatMessage(_defaultMessages2.default.APPOINTMENTS)
			)
		)
	);
	var profileMenuItems = loggedIn ? _react2.default.createElement(
		'li',
		null,
		profileInfo,
		_react2.default.createElement(
			'a',
			{ href: '#',
				onClick: logOut },
			_react2.default.createElement('i', { className: 'ion-log-out' }),
			_react2.default.createElement(
				'span',
				null,
				intl.formatMessage(_defaultMessages2.default.LOG_OUT)
			)
		)
	) : _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			'li',
			null,
			_react2.default.createElement(
				'a',
				{ href: '/join/doctors',
					onClick: function onClick() {
						(0, _doctifyUtils.fireGTMevent)('specialist_button');
					} },
				_react2.default.createElement('i', { className: 'ion-ios-medkit-outline' }),
				_react2.default.createElement(
					'span',
					null,
					intl.formatMessage(_defaultMessages2.default.ARE_YOU_A_SPECIALIST)
				)
			)
		),
		_react2.default.createElement(
			'li',
			null,

			/// pageName query param is used to signal post login redirectTo
			// e.g. need to redirect to blog if loging in from the blog
			_react2.default.createElement(
				_reactRouter.Link,
				{ to: '/login?redirectTo=' + pageName,
					className: _style.login,
					onClick: function onClick() {
						toggleMobileMenu();
						(0, _doctifyUtils.fireGTMevent)('login_button');
					} },
				_react2.default.createElement('i', { className: 'ion-log-in' }),
				_react2.default.createElement(
					'span',
					null,
					intl.formatMessage(_defaultMessages2.default.LOG_IN)
				)
			)
		),
		_react2.default.createElement(
			'li',
			null,
			_react2.default.createElement(
				'a',
				{ onClick: function onClick() {
						openSignUpModal();
						toggleMobileMenu();
						(0, _doctifyUtils.fireGTMevent)('signup_button');
					} },
				_react2.default.createElement('i', { className: 'ion-ios-personadd-outline ' + _style.smallIcon }),
				_react2.default.createElement(
					'span',
					null,
					intl.formatMessage(_defaultMessages2.default.SIGN_UP)
				)
			)
		)
	);

	return _react2.default.createElement(
		'div',
		{ className: _style.mobMenu + ' ' + 'pull-right' + ' ' + 'visible-xs' },
		_react2.default.createElement(
			'a',
			{ onClick: openMobileSearchMenu },
			_react2.default.createElement('i', { className: 'ion-ios-search' })
		),
		_react2.default.createElement(
			'a',
			{ onClick: toggleMobileMenu },
			_react2.default.createElement('i', { className: '' + (props.profileDropdownOpen || props.settingsDropdownOpen || props.mobileMenuOpen ? 'ion-android-close' : 'ion-android-menu') })
		),
		mobileMenuOpen && _react2.default.createElement(
			'div',
			{
				className: '' + (props.profileDropdownOpen || props.settingsDropdownOpen || props.mobileMenuOpen ? _style2.default.menuOverlay : ''),
				onClick: function onClick(event) {
					if (event.target === overlay) {
						(0, _doctifyUtils.closeModal)(props, overlay);
					}
				},
				ref: function ref(div) {
					overlay = div;
					if (overlay) {
						overlay.addEventListener('wheel', (0, _doctifyUtils.stopScroll)(_style.dropdownMenuContainer, overlay), true);
						overlay.addEventListener('touchmove', (0, _doctifyUtils.stopScrollMobile)(_style.dropdownMenuContainer), true);
						overlay.addEventListener('touchstart', _doctifyUtils.setLastY, true);
					}
				} },
			_react2.default.createElement(
				'ul',
				{ className: (props.profileDropdownOpen || props.settingsDropdownOpen || props.mobileMenuOpen ? _style.dropdownOnOverlay : '') + ' ' + _style.dropdownItemList + ' ' + _style.dropdownMenuContainer },
				_react2.default.createElement(
					'li',
					null,
					_react2.default.createElement(
						'a',
						{ href: 'https://vitality.co.uk/member/login', target: '_blank', rel: 'noreferrer noopener' },
						_react2.default.createElement('i', { className: 'ion-log-in' }),
						_react2.default.createElement(
							'span',
							null,
							intl.formatMessage(_defaultMessages2.default.VITALITY_MEMBERZONE)
						)
					)
				)
			)
		),
		mobileMenuOpen && _react2.default.createElement('div', { className: _style.veil })
	);
};

var hoc = (0, _reactIntl.injectIntl)(MobileMenu);
exports.MobileMenu = hoc;


// WEBPACK FOOTER //
// ./components/top-nav/lib/components/mobile-menu.js